import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MenuItem } from './shared/menu.model';
import { MenuService } from './menu.service';
import { AppConfig } from '../config/app.config';

@Component({
    selector: 'menu',
    moduleId: module.id,
    templateUrl: 'shared/menu.component.html',
    providers: [MenuService]
})
export class MenuComponent implements OnInit {
    errorMessage: string;
    menuItems: MenuItem[];
    @Output() selectedMenu: EventEmitter<string> = new EventEmitter<string>();
    appVersion: string = this.config.get('appVersion');

    constructor(private menuService: MenuService,
        private config: AppConfig) { }

    ngOnInit() { this.getMenu(); }

    getMenu() {
        this.menuService.getMenuItems()
            .then(
                menuItems => this.menuItems = menuItems,
                error => this.errorMessage = <any>error);
     }

    onMenuClicked(clickedMenu: string) {
        this.selectedMenu.emit(clickedMenu);
    }

    openMenuList(clickedMenu: MenuItem) {
        var previousVal = clickedMenu.Open;
        for (let menu of this.menuItems) {
            menu.Open = false;
        }
        clickedMenu.Open = !previousVal;
        return false; // stops click event from bubbling that would cause navigation to root page
    }
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/menu/menu.component.ts